<template>
	<div>
		<details-page-gen :options="options" />
	</div>
</template>

<script>
import DetailsPageGen from './DetailsPageGen.vue'

const config = {
	options: {
		resource: 'pickup-points',
		display: ['clientId', 'address', 'createdAt', 'updatedAt']
	}
}

export default {
	name: 'PickupPointDetails',
	components: { DetailsPageGen },
	data: () => config
}
</script>
